import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=1377d71a&scoped=true&"
import script from "./FormDialog.vue?vue&type=script&lang=js&"
export * from "./FormDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=1377d71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377d71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1377d71a')) {
      api.createRecord('1377d71a', component.options)
    } else {
      api.reload('1377d71a', component.options)
    }
    module.hot.accept("./FormDialog.vue?vue&type=template&id=1377d71a&scoped=true&", function () {
      api.rerender('1377d71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/mscHistoryBillAddress/FormDialog.vue"
export default component.exports